/**
 *
 * BariatricTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import MedicalServiceIcon from 'assets/v2/MedicalServiceIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.skyBlue};
    }
  }
`;

function BariatricTag(props) {
  return (
    <StyledTag label="Bariatric" icon={<MedicalServiceIcon />} {...props} />
  );
}

export default memo(BariatricTag);
